
import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}

//Participant/HRAs/Get/{AuthToken}/{ParticipantGuid}/	GET

const PLATFORM = '../../WsWebServiceHra/'

export const fetchParticipantResponses = createAsyncThunk('participantresponse/get', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.get(PLATFORM + "Participant/HRAs/Get/" + incomingVariable.authToken + "/" + incomingVariable.ParticipantGuid + "/")
        const data = await response.data

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})



const participantresponseSlice = createSlice({
    name: 'participantresponses',
    initialState,
    reducers: {
        participantresponseClear(state, action) {
            state.entities = initialState.entities
            state.status="idle"
        }
        ,participantresponseUpdate(state, action) {
            const data= action.payload
            state.entities[data.ParticipantResponseGuid] = data
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchParticipantResponses.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchParticipantResponses.fulfilled, (state, action) => {
                state.status = 'success'
                const loadedData = action.payload.Info

                const data = {}
                for (var i = 0; i < loadedData.length; i++) {
                    const partObject = loadedData[i]
                    data[partObject.AssmtGuid] = partObject
                }
                state.entities = data
            })
            .addCase(fetchParticipantResponses.rejected, (state, action) => {
                state.error = action.error.message

            })
         
    }
})

export const { participantresponseClear } = participantresponseSlice.actions

export default participantresponseSlice.reducer

const selectParticipantResponsesEntities = (state) => state.participantresponses.entities

export const selectParticipantResponses = createSelector(selectParticipantResponsesEntities, (entities) =>
    Object.values(entities)
)

export const selectParticipantResponsesById = (state, ParticipantResponsesId) => {
    return selectParticipantResponsesEntities(state)[ParticipantResponsesId]
}

export const selectParticipantResponsesByTypeGuid = createSelector(
    selectParticipantResponses
    , (state, ParticipantResponseTypeId_Guid) => ParticipantResponseTypeId_Guid
    , (participantresponses, guid) => {
       
        return participantresponses.filter(participantresponse => {
            return participantresponse.AssmtGuid && participantresponse.AssmtGuid === guid
        })
    }

)